import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HouseCreditModalComponent } from '../../../components/house-credit-modal/house-credit-modal.component';

@Component({
  selector: 'app-house-flat-credit-history-page',
  templateUrl: './house-flat-credit-history-page.component.html',
  styleUrl: './house-flat-credit-history-page.component.scss'
})
export class HouseFlatCreditHistoryPageComponent {

  @Input() creditTransactions: any[] = [];
  @Input() creditBalance: number = 0;
  @Input() loading: boolean = true;
  @Input() neighborhoodId: string = '';
  @Input() streetBuildingId: string = '';
  @Input() houseFlatId: string = '';
  @Output() refresh = new EventEmitter<void>();

  constructor(private modalService: NgbModal) {}

  openDeposit() {
    const modalRef = this.modalService.open(HouseCreditModalComponent);
    modalRef.componentInstance.mode = 'deposit';
    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;
    modalRef.componentInstance.streetBuildingId = this.streetBuildingId;
    modalRef.componentInstance.houseFlatId = this.houseFlatId;
    modalRef.closed.subscribe(() => this.refresh.emit());
  }

  openRefund() {
    const modalRef = this.modalService.open(HouseCreditModalComponent);
    modalRef.componentInstance.mode = 'refund';
    modalRef.componentInstance.maxAmount = this.creditBalance;
    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;
    modalRef.componentInstance.streetBuildingId = this.streetBuildingId;
    modalRef.componentInstance.houseFlatId = this.houseFlatId;
    modalRef.closed.subscribe(() => this.refresh.emit());
  }

}
